import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Box } from "./components/styled/Elements";
import { PublicRoutes } from "./routes/PublicRoutes";
import MainLayout from "./layout/MainLayout";
import { PrivateRoutes, ProfileRoutes } from "./routes/PrivateRoutes";
import ProfileLayout from "./layout/ProfileLayout";
import { AuthContext } from "./context/authContext";
import PrivateRoute from "./routes/PrivateRouteComponent";
import { useUser } from "./context/userContext";
import Registration from "./pages/auth/registration/registration";
import ProfileForVisitor from "./pages/web/profile/my-profile/ProfileForVisitor";
import HalfCompProfileForVisit from "./pages/web/profile/my-profile/HalfCompProfileForVisit";
import VisitorLayout from "./layout/VisitorLayout";
import PropertyDetails from "./pages/web/profile/properties/PropertyDetails";
import AppSettingsApi from "./services/api/appSettingsApi";
import { configureMediaSettings } from "./utils/mediaUrl";
import { safeInternalPath } from "./utils";

function App() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { user } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);
  const [filteredPrivateRoutes, setFilteredPrivateRoutes] =
    useState(ProfileRoutes);

  useEffect(() => {
    setFilteredPrivateRoutes(
      isMobile
        ? ProfileRoutes.filter((route) => route.path !== "inquiry")
        : ProfileRoutes
    );
  }, [isMobile]);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 767);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (
      isAuthenticated &&
      user &&
      Number(user?.four_step_completed) !== 1 &&
      location.pathname !== "/registration"
    ) {
      // toast.info(t("please_complete_profile_first"));
      navigate("/registration", { replace: true });
    }
    if (
      isAuthenticated &&
      Number(user?.four_step_completed) === 1 &&
      location.pathname === "/registration"
    ) {
      navigate("/my-profile", { replace: true });
    }
  }, [user, location.pathname]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    const authPages = ["/login", "/signup", "/reset-password"];
    if (!authPages.includes(location.pathname)) {
      return;
    }
    const next = safeInternalPath(
      new URLSearchParams(location.search).get("next")
    );
    if (location.pathname === "/login" && next) {
      navigate(next, { replace: true });
      return;
    }
    navigate("/my-profile", { replace: true });
  }, [location, isAuthenticated]);

  useEffect(() => {
    document.title = t("fal_hub");
  }, [language, t]);

  useEffect(() => {
    let cancelled = false;
    const loadMediaSettings = async () => {
      const settings = await AppSettingsApi.fetchAppSettings(language);
      if (cancelled || !settings) {
        return;
      }
      configureMediaSettings({
        mediaUseS3: Boolean(settings.media_use_s3),
        mediaPublicBaseUrl: settings.media_public_base_url || "",
        mediaLocalStorageUrlPrefix: settings.media_local_storage_url_prefix || "",
      });
    };
    loadMediaSettings();
    return () => {
      cancelled = true;
    };
  }, [language]);

  return (
    <Box>
      <ToastContainer
        style={{ zIndex: 999999 }}
        position={language === "ar" ? "top-left" : "top-right"}
        rtl={language === "ar"}
      />
      <Routes>
        {PublicRoutes.map((route, key) => (
          <Route key={key} {...route} />
        ))}
        {/* <Route path="/" element={<MainLayout />}>
          {PrivateRoutes.map((route, key) => (
            <Route key={key} {...route} />
            ))}
            </Route> */}
        <Route
          path="registration"
          element={
            <PrivateRoute
              isAuthenticated={isAuthenticated}
              element={<Registration />}
            />
          }
        />
        <Route path="profile/:username" element={<ProfileForVisitor />} />
        <Route
          path="profile/:username/inquiry-form"
          element={<HalfCompProfileForVisit />}
        />
        <Route path="/" element={<ProfileLayout />}>
          {filteredPrivateRoutes.map((route, key) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  element={route.element}
                />
              }
            />
          ))}
        </Route>
        
        <Route path="/listing/" element={<ProfileLayout />}>
          <Route
            path="listing-details/:id"
            element={<PropertyDetails />}
          />
        </Route>
        <Route path="/visitor-listing/" element={<VisitorLayout />}>
          <Route
            path="listing-details/:username/:id"
            element={<PropertyDetails />}
          />
        </Route>
      </Routes>
    </Box>
  );
}

export default App;
